export default __webpack_public_path__ + "static/dot-pattern-c642b3dc1c85a37da3fe03a9f7a425d8.svg";